import { useInfiniteQuery } from "@tanstack/react-query";
import api from "../services/axios";
// import { getData } from "../Components/Helper";

const getArtistQueryParams = (selectedFilter, selectedCity) => {
  const queryParams = new URLSearchParams();
  queryParams.append("view", "artists")
  const musicGenres =
    selectedFilter?.musicGenre
      ?.filter((item) => item.checked)
      ?.map((item) => item.value)
      ?.join("|") || [];

  if (musicGenres?.length) queryParams.append("musicGenre", musicGenres);
  if (selectedFilter?.artist)
    queryParams.append("type", selectedFilter?.artist);
  if (selectedCity) queryParams.append("city", selectedCity);
  return queryParams;
};

export const useFetchArtists = (selectedFilter, selectedCity) => {
  return useInfiniteQuery({
    queryKey: ["api/artists", { selectedFilter, selectedCity }],
    queryFn: async ({ pageParam = 0 }) => {
      const queryParams = getArtistQueryParams(selectedFilter, selectedCity);
      const token = localStorage.getItem("userToken");
      const jsonToken = JSON.parse(token);
      const { data } = await api.get(
        `api/artists?page=${pageParam}&${queryParams}`,
        {
          headers: {
            Authorization: jsonToken ? `Bearer ${jsonToken}` : null,
          },
        }
      );

      if (data?.ok === false) {
        throw new Error(data?.message || "Something went wrong");
      }

      return data;
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.cursor ?? undefined;
    },
    placeholderData: {},
  });
};
